import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import edit_icon from '../../../../../Asset/images/icon/edit_icon.svg'
import save_icon from '../../../../../Asset/images/icon/save_icon.svg'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import { Playlist } from '../../../../../constants/Playlist';
import { Users } from '@/constants/Users';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { useAtomValue } from 'jotai';


const PlaylistHeader = ({ playlist, onEdit, onDelete, onShuffle, onReorderClicked, isReordering, onSave }) => {
	const userInfo = useAtomValue(userInfoAtom);
	const isStudioPlaylist = playlist?.type === Playlist.SPL;
	const isStudioOwner = userInfo?.user?.userType === Users.studioOwner;
	const [shuffleClicked, setShuffleClicked] = useState(false);

	const hasAccess =
		(
			!isStudioPlaylist || isStudioOwner
		);
	const handleEdit = e => {
		e.preventDefault();
		onEdit(e, playlist);
	};

	const handleDelete = e => {
		e.preventDefault();
		onDelete(e, playlist);
	};

	const handleShuffle = e => {
		e.preventDefault();
		setShuffleClicked(true);
		onShuffle(e, playlist?.type, playlist?.videos || []);

		setTimeout(() => {
			setShuffleClicked(false);
		}, 7000);
	};
	const handleReorder = e => {
		e.preventDefault();
		onReorderClicked(e, playlist?.videos || [])
	}
	const handleSave = e => {
		e.preventDefault();
		onSave()
	}


	return (
		<div className="">
			<div className="d-flex justify-content-between align-items-center md:gap-2 mb-2">
				<div className="d-flex flex-row gap-1 align-content-center mb-0 ">
					<p className='playlist_name'>{playlist?.name}</p>
					<div className='d-flex' onClick={handleEdit}>{isReordering && (<EditIcon style={{ color: '#3cb4e4' }} />)}</div>
				</div>
				<div className="c-featured_box-left-b4 m-0 d-inline-flex gap-1 items-center-center">
					{hasAccess && playlist?.type !== Playlist.FPL && (
						isReordering ? (
							<button onClick={handleEdit} className="d-flex align-content-center outline__primary__btn shuffle fw-normal small">
								<span>
									<PlaylistAddIcon style={{ color: '#3cb4e4', fontSize: '1.5rem' }} />
								</span>
								<span className="d-none d-lg-flex align-self-center m-0">Add/Remove Videos</span>
							</button>
						) : (
							<button onClick={handleReorder}
								className="d-inline-flex align-content-center outline__primary__btn shuffle "
								style={{
									pointerEvents: shuffleClicked ? 'none' : 'auto',
									opacity: shuffleClicked ? 0.5 : 1
								}}>
								<span>
									<EditIcon style={{ color: '#3cb4e4', fontSize: '1.5rem' }} />
								</span>
								<span className="d-none d-lg-flex align-self-center m-0">Edit</span>
							</button>
						)
					)}
					{
						!isReordering ? (
							<button onClick={!isReordering ? handleShuffle : undefined}
								className={`d-inline-flex outline__primary__btn shuffle ${!hasAccess ? 'disabled' : ''}`}
								style={{ pointerEvents: !hasAccess ? 'none' : 'auto', opacity: !hasAccess ? 0.5 : 1 }}>
								<span>
									<ShuffleIcon style={{ color: "#3cb4e4", fontSize: "1.5rem" }} />

								</span>
								<span className="d-none d-lg-flex align-self-center m-0">Shuffle</span>
							</button>
						) : (
							<button onClick={handleSave} className="d-inline-flex text-white align-content-center outline__primary__btn__save shuffle" style={{ backgroundColor: "#3cb4e4" }}>
								<span>
									<SaveIcon style={{ color: "white", fontSize: "1.5rem" }} />
								</span>
								<span className="d-none d-lg-flex align-self-center m-0 fw-normal">Save</span>
							</button>
						)
					}
				</div>
			</div>
		</div>
	);
};

export default PlaylistHeader;
